import { feathers } from '@/feathers-client';
import { PreferenceKeys } from '@/Core/config/preferences';
import { ALL_VITALS } from '@/Core/config/vitals';

export default {
  namespaced: true,

  state: {
    [PreferenceKeys.ContactsHeaders]: [],
    [PreferenceKeys.ContactFieldFavorites]: [],
    [PreferenceKeys.OrderedVitals]: [],
    [PreferenceKeys.ContactDraggableCards]: [],
  },
  
  mutations: {
    setUserPreferences(state, { key, value }) {
      state[key] = value;
    },
  },

  actions: {
    async findUserPreferences({ commit, dispatch, state }, { key }) {
      if(state[PreferenceKeys.ContactsHeaders].length) return;
      const response = await feathers.service('user-preferences').get(key);
      let { value } = response;
      value = JSON.parse(value);
      if (value && value.length) {
        commit('setUserPreferences', { key, value });
      } else if(key === PreferenceKeys.OrderedVitals) {
        dispatch('saveUserPreferences', {key: PreferenceKeys.OrderedVitals, value: ALL_VITALS})
      }
    },
    async saveUserPreferences({ commit, dispatch, rootState }, { key, value }) {
      commit('setUserPreferences', { key, value });
      value = JSON.stringify(value);
      await feathers.service('user-preferences').update(key, { value });
    },
  },
};
